<template>
  <div :class="{ 'warnings': true, 'is-loading': !loaded }">
    <fieldset>
      <legend>Warnings</legend>

      <d-alert
        v-if="referenceId === 0"
        theme="light"
        show
        class="text-center">
        You will be able to see and add warnings after saving this {{ itemName }}.
      </d-alert>

      <d-alert
        v-if="loadError"
        theme="warning"
        show
        class="text-center">
        An error occurred during loading warnings.
      </d-alert>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pr-3 mb-3">
        <d-button
          v-if="!allWarningsDisplayed && hasArchivedWarnings"
          theme="secondary"
          @click.prevent="showAllWarnings"
          outline
          class="ml-auto">
          Show archived warnings
        </d-button>
        <d-button
          v-if="allWarningsDisplayed && hasArchivedWarnings"
          theme="secondary"
          @click.prevent="hideArchivedWarnings"
          outline
          class="ml-auto">
          Hide archived warnings
        </d-button>
        <d-button
          theme="success"
          @click.prevent="addWarning"
          outline
          :class="{ 'ml-2': hasArchivedWarnings, 'ml-auto': !hasArchivedWarnings }">
          Add warning
        </d-button>
      </d-row>

      <d-row>
        <warnings-list-item
          v-for="(warningData, index) of filteredWarnings"
          :key="'warnings-list-item-' + index"
          :warningData="warningData" />
      </d-row>

      <d-alert
        v-if="loaded && !loadError && referenceId !== 0 && warnings.length === 0"
        theme="light"
        show
        class="text-center">
        There are no active warnings for this {{ itemName }}.
      </d-alert>
    </fieldset>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import WarningsListItem from './WarningsListItem.vue';

export default {
  name: 'warnings',
  components: {
    'warnings-list-item': WarningsListItem
  },
  props: {
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      required: true
    },
    itemName: {
      type: String,
      required: true
    }
  },
  computed: {
    hasArchivedWarnings () {
      return this.warnings.filter(warning => warning.is_archived).length > 0;
    },
    filteredWarnings () {
      if (this.allWarningsDisplayed) {
        return this.warnings;
      }

      return this.warnings.filter(warning => !warning.is_archived);
    }
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      allWarningsDisplayed: false,
      warnings: []
    };
  },
  mounted () {
    if (this.referenceId === 0) {
      this.loaded = true;
    } else {
      this.loadWarnings();
    }

    this.$bus.$on('warnings-list-reload', this.reload);
  },
  methods: {
    loadWarnings () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/warnings/items',
        params: {
          pagination: 0,
          where: {
            reference_id: this.referenceId,
            reference_type: this.referenceType
          }
        },
        loadedKey: 'loaded',
        outputKey: 'warnings',
        errorKey: 'loadError'
      });
    },
    addWarning () {
      this.$bus.$emit('show-warning-popup', 'add', this.referenceType, this.referenceId);
    },
    showAllWarnings () {
      this.allWarningsDisplayed = true;
    },
    hideArchivedWarnings () {
      this.allWarningsDisplayed = false;
    },
    reload () {
      this.loaded = false;
      this.loadWarnings();
    }
  },
  beforeDestroy () {
    this.$bus.$off('warnings-list-reload', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.warnings {
  margin: 30px 0;
  position: relative;

  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }
}
</style>
